import { HardHat } from 'lucide-react';

export default function DashboardHeader({ showAllConstructions, selectedConstruction }) {
    return (
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
                <h1 className="text-2xl font-bold text-text-primary flex items-center gap-2">
                    <HardHat className="text-secondary" size={28} />
                    İnşaat Yönetimi
                </h1>
                <p className="text-text-secondary text-sm mt-1">
                    {showAllConstructions ? 'Tüm İnşaatlar' : selectedConstruction?.name || 'Seçili proje yok'}
                </p>
            </div>
            <div className="text-right">
                <p className="text-xs text-text-muted">Son güncelleme</p>
                <p className="text-sm text-text-secondary">
                    {new Date().toLocaleDateString('tr-TR', { weekday: 'long', day: 'numeric', month: 'long' })}
                </p>
            </div>
        </div>
    );
}
